import { useQuery } from "@tanstack/react-query";
import {
  getAllEfteruddannelsesperiodeIndberetninger,
  getEfteruddannelsesPeriode,
} from "../api/efteruddannelse";
import type { EfteruddannelsesPeriodeDetail } from "../interfaces/efteruddannelse";
import type { EfteruddannelsesperiodeIndberetningOverviewModel } from "../interfaces/efteruddannelsesperiodeIndberetningOverview";

export const useHentEfteruddannelsesperiode = (id?: string) => {
  return useQuery<EfteruddannelsesPeriodeDetail>({
    queryKey: ["efteruddannelsesperiode", id],
    queryFn: () => getEfteruddannelsesPeriode(id as string),
    enabled: Boolean(id),
  });
};

export const useHentAlleEfteruddannelsesperiodeIndberetninger = () => {
  return useQuery<EfteruddannelsesperiodeIndberetningOverviewModel[]>({
    queryKey: ["efteruddannelsesperiode", "all-period-reports"],
    queryFn: getAllEfteruddannelsesperiodeIndberetninger,
  });
};
